import StandardQueryTable from "@/components/StandardQueryTable";
import { Module, PATH_TIMESHEET_ENTRIES_SHIFT_REPORTS } from "@/constants";
import { TimesheetEntriesService } from "@/modules/timesheet-entries/services/timesheetEntries";
import { readTimesheetEntry } from "@/schemas/timesheetEntry";
import { ReadTimesheetEntry } from "@/types/timesheetEntry";
import { memo } from "react";
import { generatePath } from "react-router-dom";

export const TimesheetEntriesDirectory = memo(() => {
  const name = "timesheetEntries";

  return (
    <StandardQueryTable<ReadTimesheetEntry>
      schema={readTimesheetEntry}
      name={name}
      fetchList={TimesheetEntriesService.getList}
      pathBuilder={(row) =>
        generatePath(PATH_TIMESHEET_ENTRIES_SHIFT_REPORTS, {
          shiftReportId: row.shift_report_id,
        })
      }
      actions={[]}
      tableFeatures={{
        exportSettings: {
          moduleName: Module.TimesheetEntriesContractors,
        },
      }}
    />
  );
});
